import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthIntervenienteComponent } from '../pages/auth-interveniente/auth-interveniente.component';
import { ComplementoCadastroComponent } from '../components/complemento-cadastro/complemento-cadastro.component'; 
import { CadastroInvestidorComponent } from '../pages/cadastro-investidor/cadastro-investidor.component';
import { LostPasswordComponent } from '../pages/lost-password/lost-password.component';

const routes: Routes = [
    { path: 'reset/senha', component: LostPasswordComponent },
    { path: "cadastro", component: CadastroInvestidorComponent},
    { path: "complemento-cadastro", component: ComplementoCadastroComponent},
    // { path: 'home/interveniente', component: AuthIntervenienteComponent}
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes, { 
                useHash: true 
            }
        )
    ],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
